import { Logo } from '@seek/logo';
import type { Brand } from '@seek/melways-sites';
import {
  Box,
  Text,
  IconChevron,
  Inline,
  MenuItemLink,
  MenuRenderer,
  IconLanguage,
  IconTick,
} from 'braid-design-system';

import { SHAREABLE_PROFILE_PAGE_URL } from 'src/components/Router';
import { useShareableProfileSlug } from 'src/components/Router/useShareableProfileSlug';
import { useAppConfig } from 'src/modules/appConfig';

import * as styles from './Header.css';

const languageCodeToDisplayLabel = {
  en: 'English',
  th: 'ภาษาไทย',
  id: 'Bahasa',
};

export const Header = () => {
  const { brand, language, zone } = useAppConfig();

  const brandLowercase = brand.toLowerCase() as Brand;

  const shareableProfileSlug = useShareableProfileSlug();

  const shareableProfileUrl = `${SHAREABLE_PROFILE_PAGE_URL.replace(
    ':name',
    shareableProfileSlug,
  )}`;

  const showLanguageToggle = zone === 'asia-3' || zone === 'asia-4';
  const showThaiLanguageOption = zone === 'asia-3';
  const showBahasaLanguageOption = zone === 'asia-4';

  return (
    <Box>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="spaceBetween"
        width="full"
        paddingTop="large"
        position="relative"
      >
        <Box paddingRight="large">
          <Logo brand={brandLowercase} />
        </Box>
        {showLanguageToggle && (
          <div className={styles.languageToggle}>
            <MenuRenderer
              offsetSpace="small"
              align="right"
              reserveIconSpace
              trigger={(triggerProps, { open }) => (
                <Box userSelect="none" cursor="pointer" {...triggerProps}>
                  <Inline space="xsmall" alignY="center">
                    <IconLanguage size="xsmall" />
                    <Text size="small">
                      {languageCodeToDisplayLabel[language]}{' '}
                      <IconChevron
                        direction={open ? 'up' : 'down'}
                        alignY="lowercase"
                      />
                    </Text>
                  </Inline>
                </Box>
              )}
            >
              <MenuItemLink
                href={shareableProfileUrl}
                icon={language === 'en' && <IconTick />}
              >
                {languageCodeToDisplayLabel.en}
              </MenuItemLink>
              {showThaiLanguageOption && (
                <MenuItemLink
                  href={`/th${shareableProfileUrl}`}
                  icon={language === 'th' && <IconTick />}
                >
                  {languageCodeToDisplayLabel.th}
                </MenuItemLink>
              )}
              {showBahasaLanguageOption && (
                <MenuItemLink
                  href={`/id${shareableProfileUrl}`}
                  icon={language === 'id' && <IconTick />}
                >
                  {languageCodeToDisplayLabel.id}
                </MenuItemLink>
              )}
            </MenuRenderer>
          </div>
        )}
      </Box>
    </Box>
  );
};
